<template>
  <div>

   <div class="login-form mt-3">
        <!-- <div class="login-header bg-red-text">
            <h2 class="text-center mb-0">Register</h2>
        </div> -->
        <div class="login-body">
            <form class="form-wrap">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Program</label>
                            <input 
                            class="disabled"
                            name="program" 
                            type="text" 
                            v-model="dataprop.title"
                            disabled
                            v-validate="'required'"
                            >
                            <div class="text-danger">{{ veeErrors.first('program') }}</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Full Name</label>
                            <input
                            name="fullname" 
                            type="text" 
                            placeholder="Full Name"
                            v-model="data.fullname"
                            v-validate="'required'"
                            >
                            <div class="text-danger">{{ veeErrors.first('fullname') }}</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Perusahaan/Instansi/Pribadi</label>
                            <input 
                            name="instansi" 
                            type="text" 
                            placeholder="Instansi"
                            v-model="data.instansi"
                            v-validate="'required'"
                            >
                            <div class="text-danger">{{ veeErrors.first('instansi') }}</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Email Address</label>
                            <input
                            name="email" 
                            type="email" 
                            placeholder="Email Address"
                            v-model="data.email"
                            v-validate="'required'"
                            >
                            <div class="text-danger">{{ veeErrors.first('email') }}</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Whatsapp</label>
                            <input
                            name="phone" 
                            type="text" 
                            placeholder="Whatsapp"
                            v-model="data.phone"
                            v-validate="'required'"
                            data-vv-as="Whatsapp"
                            >
                            <div class="text-danger">{{ veeErrors.first('phone') }}</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <button class="btn btn-success" @click.prevent="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>
</template>

<script>
    export default {
      props: ["dataprop"],
      data() {
        return {
          url: "",
          type: "",
          data: {},
      };
  },
  created() {
    this.initial();
},
methods: {
    initial() {
      //
  },
  submit() {
   this.$validator.validate().then(valid => {
    if (valid) {
        this.data.program = this.dataprop
        this.axiosForm(this.data)
    }
});
},

axiosForm(data){

    let formData = this.formData(data)
    let url = `/registercourse`

    axios.post(url,data)
    .then(res => {
        let dataEmit = {
            action:'notif',
            data
        }
        this.$emit("datacomponent",dataEmit);    
    })
    .catch(err =>{
        this.alertError('error') 
    })
},
formData(obj){
    var formData = new FormData();
    for (var key in obj) {
        formData.append(key, obj[key]);
    }
    return formData;
},
alertError(msg) {
  this.$swal({
    icon: "error",
    title: 'Error',
    text: 'Something wrong! Please try again later.',
    type: "error",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
}).then((result) => {
    if (result.value) {
    }
});
},
},
};
</script>
<!-- <style src='vue-multiselect/dist/vue-multiselect.min.css'></style> -->
<style>
  .multiselect__input{
    width:0px!important; 
}
input.disabled{
    background: #eee;
}
</style>
